const notesTemplates = [
    {
        "label": "_GeneralPhysicalExam",
        "values": [
            "General: Normotensive, in no acute distress",
            "Head: Normocephalic, no lesions",
            "Eyes: PERRLA, EOM's full, conjunctivae clear, fundi grossly normal",
            "Ears: EAC's clear, TM's normal",
            "Nose: Mucosa normal, no obstruction",
            "Throat: Clear, no exudates, no lesions",
            "Neck: Supple, no masses, no thyromegaly, no bruits",
            "Chest: Lungs clear, no rales, no rhonchi, no wheezes",
            "Heart: RR, no murmurs, no rubs, no gallops",
            "Abdomen: Soft, no tenderness, no masses, BS normal",
            "GU: Normal, no lesions, no discharge, no hernias noted",
            "Pelvic: BUS normal, no discharge, cervix normal, uterus and adnexae normal",
            "Rectal: No lesions, no hemorrhoids, stool heme negative",
            "Back: Normal curvature, no tenderness",
            "Extremities: FROM, no deformities, no edema, no erythema",
            "Neuro: Physiological, no localizing findings",
            "Skin: Normal, no rashes, no lesions noted",
            "Labs: all normal",
            "Prostate: Smooth, symmetrical, non-tender, sulci clearly palpable, Hemmoccult ??",
            "Extremities: Warm, well perfused, no edema",
            "anxity controlled on medication.  patint states has occasional tingling in hands, denies any recently",
            "I spoke with pt over live video chat today in place of a physical appointment due to concerns of potential spread of illness. Pt denies any chest pain or SOB. Pt denies any fever or chills. Pt does not appear to be in respiratory distress or using accessory muscles"
        ]
    },
    {
        "label": "AbdominalPain",
        "values": [
            "Here for acute onset of abdominal pain",
            "Pain has occurred intermittently for more than 1 week",
            "Pain is associated with epigastric burning sensation, worse with Valsalva or after large meals",
            "Pain is triggered by",
            "Pain is intense and constant",
            "Pain level (scale of 1-10): ??",
            "Associated with fevers",
            "No associated fevers",
            "Associated with nausea and vomiting",
            "Associated with abdominal swelling and absence of bowel movements for past few days",
            "Pain is associated with diarrhea",
            "Pain is associated with flank pain radiating to bladder area",
            "Denies possibility of pregnancy",
            "Suspects may be pregnant",
            "Associated with malodorous vaginal discharge",
            "Associated with urinary frequency and dysuria",
            "Pain worse in pre-menstural time frame",
            "Associated with constipation",
            "Associated with weight loss",
            "Vaginal bleeding",
            "States is pregnant"
        ]
    },
    {
        "label": "Abscess",
        "values": [
            "Here with progressive abscess, painful",
            "Has been present for ??",
            "Recently became red, painful",
            "Spontaneous drainage",
            "No spontaneous drainage",
            "Pain level (scale of 1-10): ??"
        ]
    },
    {
        "label": "Acne",
        "values": [
            "Here for evaluation of acne",
            "Here for re-evaluation of acne",
            "Papulo-pustular eruption improved",
            "Mainifested mainly as papulo-pustular eruption",
            "Face primarily affected",
            "Some distribution in interscapular back",
            "Acne involving the back"
        ]
    },
    {
        "label": "Admission H&P",
        "values": [
            "ADMISSION HISTORY AND PHYSICAL: Colon patient appear for physical exam today.",
            "CC: ??",
            "HPI: ??",
            "Drug allergies: ??",
            "NKDA",
            "Medications: ??",
            "Past medical and surgical history, family history and social history, see page at end of history",
            "Functional Inquiry",
            "HEENT: Denies vision problems. Denies hearing problems. No dysphagia, odynophagia. No lumps in neck. No epistaxis. No hemoptysis.",
            "Cardiac: Denies CP, CPOE, palpitations",
            "Respiratory: Denies SOB, SOBOE, cough, hemoptysis, wheeze",
            "GI: No NVD, no diarrhea, no melena, no hematochezia, no constipation. BMs regular. UTD on colonoscopy. Denies abdominal pain",
            "GU: Denies dysuria, hematuria, incontinence",
            "GU: Denies erectile dysfunction. Denies frequent nocturia. No testicular masses or pain",
            "GU: Denies abnormal vaginal bleeding, denies pelvic pain or discomfort, no sexual dysfunction",
            "MSK: Denies swelling or pain",
            "Neuro: Denies seizures, LOC, ataxia or vertigo symptoms",
            "Skin: Denies rashes, jaundice or lesions"
        ]
    },
    {
        "label": "AllergicRhinitis",
        "values": [
            "Seasonal allergy symptoms, recurrant for ?? ",
            "Perennial allergy symptoms, worse recently",
            "Sneezing, airway obstruction, watery rhinorrhea",
            "Eyes watering, itchy, no erythema or discharge",
            "Some post-nasal drainage with cough",
            "No wheezing",
            "Some nocturnal wheezing"
        ]
    },
    {
        "label": "AnalPainItching",
        "values": [
            "Here with anal pain and itching",
            "Associated with rectal bleeding",
            "No rectal bleeding",
            "Itching worse at night, wakes patient up in middle of night",
            "Associated with rectal discharge",
            "No associated rectal discharge",
            "Recent diarrhea",
            "Associated with constipation",
            "Sensation of perianal mass",
            "Pain level (scale of 1-10): ??"
        ]
    },
    {
        "label": "Anemia",
        "values": [
            "Here for evaluation of anemia",
            "Here for follow-up of anemia",
            "Feeling well, no acute concerns",
            "Complaining of fatigue, limited exertional ability",
            "No bleeding, no epistaxis,  no ecchymoses",
            "No emesis, no hematemesis, no melena",
            "Symptoms have been insidiously worsening for months",
            "Symptoms have been acute in onset, noted in past few days",
            "Medications remain unchanged",
            "New medications:",
            "No dizziness"
        ]
    },
    {
        "label": "Asthma,COPD",
        "values": [
            "Here with h/o increased wheeze and SOB for ?? days.",
            "Nonproductive cough.",
            "Has had recent nasal congestion, consistant with cold symptoms.",
            "Has noted increase rhinorrhea consistant with usual allergy symptoms.",
            "Cough productive of green sputum.",
            "Denies fever, chills.",
            "Low grade fever, with chills.",
            "Positive fever to , with chills.",
            "Is using Albtuerol ?? times per week.",
            "Using nebulizer",
            "Using Atrovent",
            "Has indoor cats.",
            "Smokes ?? packs per day x ?? yrs.",
            "Nonsmoker",
            "No change in chronic dyspnea"
        ]
    },
    {
        "label": "AutoAccident",
        "values": [
            "Here for follow up after motorvehicle accident",
            "Was hit from behind while stopped in traffic",
            "Was hit from side by oncoming vehicle",
            "Ran into vehicle in front",
            "Complains of neck pain",
            "Complains of lumbar pain",
            "Pain was immediate",
            "Pain crescendoed over the ensuing 24-48hrs",
            "Pain level (scale of 1-10): ??",
            "No loss of consciousness",
            "Not seen in ER prior to today",
            "Seen in ER at the time"
        ]
    },
    {
        "label": "Back pain",
        "values": [
            "Patient is a ?? year old ?? who presents to clinic today with complaints of low back pain.",
            "The pain is sharp",
            "The pain is constant",
            "The pain is intermittent, with episodes that last ?? and occur with ?? frequency. Triggered by ??",
            "The pain is achy",
            "The pain radiates down the ?? leg to the knee",
            "The pain radiates down the leg ?? to the heel",
            "The patient states the pain has remained unchanged since onset",
            "The patient states the pain has gotten worse over the past ??",
            "No urinary or fecal incontinence",
            "Patient has not had any imaging studies",
            "Has had imaging studies done:"
        ]
    },
    {
        "label": "BackStrain",
        "values": [
            "Here with ?? day history of lumbar pain.",
            "Here with ?? day history of shoulder pain.",
            "Here with ?? day history of neck pain.",
            "Pain began acutely after ??",
            "Denies known trauma.",
            "Denies unusual activity.",
            "Pain is dull, nonradiating.",
            "Pain is sharp, radiating to the knee.",
            "Pain is sharp, radiating to the foot.",
            "Pain is sharp, radiating to the shoulder",
            "Pain is sharp, radiating to the elbow.",
            "Pain level (scale of 1-10): ??",
            "Denies paresthesias, or motor weakness.",
            "Associated with paresthesias in the ??",
            "Denies motor weakness.",
            "Pain worse with ??",
            "Pain improved with ??",
            "Pain relieved somewhat with OTC analgesics.",
            "Pain not relieved with OTC analgesics.",
            "Patient has prior h/o chronic back pain",
            "Patient has no prior h/o back injury.",
            "Nonsmoker.",
            "Smokes"
        ]
    },
    {
        "label": "ChestPain",
        "values": [
            "Patient is C/O chest pain",
            "The pain has been present for",
            "It is described as pressure",
            "It is located in the substernal region.",
            "It radiates to the left arm.",
            "It radiates to the back.",
            "It radiates to the jaw.",
            "There is no radiation of the pain.",
            "The pain is related to activity.",
            "There is no relationship to activity.",
            "The patient has not taken anything for the pain.",
            "The patient took ??  for the pain and got relief.",
            "There has been no nausea or vomiting.",
            "The patient has had SOB.",
            "The patient was not SOB."
        ]
    },
    {
        "label": "Constipation",
        "values": [
            "Here for recent onset of constipation",
            "Here for worsening of chronic constipation",
            "Symptoms are unusual and developed suddenly",
            "Often resists urge to defecate due to time constraints",
            "Denies long-term laxative use",
            "Associated with bloating and sharp, severe pain",
            "Associated with blood in stool",
            "Peri-rectal pain with bowel movements",
            "Pain level (scale of 1-10): ??",
            "Not taking any new medications",
            "Symptoms began when started taking new analgesics",
            "Denies pregnancy",
            "Associated with weight gain, increased fatigue, dry skin, cold intolerance",
            "Associated with cramping in LLQ abdomen",
            "Associated with bouts of diarrhea in addition to constipation, with abdominal cramping"
        ]
    },
    {
        "label": "Depression",
        "values": [
            "Here for follow up of depression",
            "Notes improvement in fatigue, appetitie",
            "Status is basically the same, without significant change from last visit",
            "Sleep disturbance improved",
            "Somnolence with medications",
            "Continues medications without difficulty",
            "Never did start medications given last time due to ??",
            "No noted untoward effects of medication",
            "Receiving behavioral health counseling"
        ]
    },
    {
        "label": "Dermatitis",
        "values": [
            "Here for evaluation of rash",
            "Scattered papules spreading on extremities",
            "Involving trunk",
            "Macular eruption, flat and scaling",
            "Spread from initial area",
            "Has been present for several weeks",
            "Highly pruritic",
            "Not pruritic",
            "Not responsive to otc HC cream",
            "Rash onset: ??",
            "Precipitating factors: ",
            "Areas involved: ",
            "Interventions to date:"
        ]
    },
    {
        "label": "diabetes",
        "values": [
            "diabetes"
        ]
    },
    {
        "label": "DiabetesHTNHyperlipidemia",
        "values": [
            "Here for follow up of diabetes, hyperlipidemia and hypertension",
            "Here for follow up of diabetes and hyperlipidemia",
            "Here for follow up of diabetes and hypertension",
            "Here for follow up of hyperlipidemia and hypertension",
            "Here for follow up of hypertension",
            "Here for follow up of diabetes",
            "Here for follow up of hyperlipidemia",
            "Taking medications without difficulty",
            "Doing well, no c/o increased thirst, or hypoglycemia.",
            "Doing well, no new complaints",
            "Doing well, only complaint is ??",
            "Following DM diet.",
            "Self-checked blood glucose ??",
            "Home BP range ??",
            "No compalints of headache, chest pain",
            "Complains of numbness of lower extremities intermittantly",
            "No complaints of foot numbness or paresthesias",
            "Following low chol diet.",
            "Exercising regularly"
        ]
    },
    {
        "label": "Diarrhea",
        "values": [
            "Patient presents with diarrhea for ?? days",
            "Describes diarrhea as ??",
            "No blood in stools",
            "Notes BRBPR, which patient describes as ??",
            "Frequency of BM:  ??",
            "Diarrhea is worsening since onset of illness",
            "Diarrhea is improving since onset of illness",
            "No nausea or vomiting",
            "Complains of nausea without vomiting",
            "Complains of nausea and vomiting",
            "Able to tolerate orals",
            "Not able to tolerate orals",
            "No abdominal pain",
            "Associated with abdominal pain",
            "Pain located ??",
            "Describes pain as ??",
            "Pain level (scale 1-10):  ??",
            "No fever",
            "Subjective fever, but has not actually measured it",
            "Fever to ?? F",
            "Exposed to someone with similar symptoms",
            "No ill contacts",
            "No eating or drinking of potentially contaminated food and water",
            "Had dined out at restaurant just prior to onset",
            "No foreign travel",
            "Has not tried any treatments to assist with symptoms",
            "Has tried to treat symptoms with ??",
            "Decreased urination",
            "Normal urination"
        ]
    },
    {
        "label": "EarInfection",
        "values": [
            "Pain in ears for 6 days",
            "No drainage",
            "There is drainage from ??",
            "Felt feverish but did not measure",
            "Running fevers to ??",
            "Tried to clean ears with Q-tips but too painful."
        ]
    },
    {
        "label": "ENT:Dizziness",
        "values": [
            "The patient is referred for evaluation of dizziness.",
            "The problem has been present for several days.",
            "The problem has been present for several weeks.",
            "The problem has been present for several months.",
            "The problem has been present for several years.",
            "The problem has been present for many years.",
            "Dizziness is described as room spinning, with the sensation that the world is moving around.",
            "Dizziness is described as a difficult to explain sensation of movement.  The patient feels that there surroundings are moving in varying directions.",
            "Dizziness is not described as room spinning, nor is there sensation that the environment is moving.  There is a general sense of lightheadedness with loss of balance.",
            "There are no discreet episodes, the patient continuously feels dizzy.",
            "There are discrete episodes of dizziness",
            "During an episode, dizziness lasts for several seconds to a minute.",
            "During an episode, dizziness lasts for several minutes.",
            "During an episode, dizziness lasts for several hours.",
            "During an episode, dizziness lasts for hours to days.",
            "Symptoms are not dependent on position or head rotation.",
            "Symptoms are dependent on position in the following way:",
            "Dizziness is caused by rolling the head to the right.",
            "Dizziness is caused by rolling the head to the left.",
            "Dizziness is caused by bending down.",
            "Dizziness is caused by looking up.",
            "Dizziness is caused by standing up quickly.",
            "Dizziness is caused by a quick changes in position such as quickly rotating the head.",
            "Loud noises and bearing down to cause increased body pressure do not cause dizziness.",
            "Loud noises can induce an attack of dizziness.",
            "Bearing-down to increase the pressure inside the body can cause dizziness",
            "There is associated difficulty with walking due to lack of balance.",
            "There is no associated difficulty walking due to lack of balance.",
            "The following symptoms are associated:",
            "Nausea",
            "Vomiting",
            "Hearing loss.",
            "Ringing.",
            "Ear pain.",
            "Ear drainage.",
            "Sensation of fullness in the ear.",
            "Ear itching.",
            "The following symptoms are denied:",
            "Nausea",
            "Vomiting",
            "Ear drainage.",
            "Ringing.",
            "Hearing loss.",
            "Ear fullness.",
            "Ear pain.",
            "Ringing involves both ears and is described as continuous and non pulsatile.",
            "Ringing involves the right ear and is described as continuous and non-pulsatile.",
            "Ringing involves the left ear and is described as continuous and non-pulsatile.",
            "Hearing loss involves the right ear.",
            "Hearing loss involves the left.",
            "Hearing loss involves both ears.",
            "Hearing loss has been constant and progressive without fluctuation",
            "Hearing loss fluctuates",
            "The patient denies significant noise exposure.",
            "Noise exposure was mainly to the right ear.",
            "Noise exposure was mainly to the left ear.",
            "Head trauma, ear surgery, neurosuegery, meningitis, and ototoxic drug history are denied.",
            "The patient believes they were sick with cold or flu before symptoms started.",
            "The patient did not have any symptoms of cold or flu before symptoms started.",
            "The patient cannot think of anything that caused the symptoms started.",
            "The following treatments have been tried thus far:",
            "Meclizine",
            "Oral benzodiazepines.",
            "Decongestants.",
            "Antihistamines.",
            "No therapy has been successful in reducing symptoms."
        ]
    },
    {
        "label": "ENT:HearingLoss",
        "values": [
            "The patient is referred for evaluation of hearing loss.",
            "The problem has been present for several days.",
            "The problem has been present for several weeks.",
            "The problem has been present for several months.",
            "The problem has been present for several years.",
            "Symptoms involve the right ear.",
            "Symptoms involve the left ear.",
            "Symptoms involve both ears.",
            "Hearing loss was sudden in onset.",
            "Hearing loss was slowly progressive.",
            "Hearing loss fluctuates and has varying severity.",
            "The following symptoms are associated:",
            "Ringing.",
            "Ear pain.",
            "Ear drainage.",
            "Dizzyness.",
            "Sensation of fullness in the ear.",
            "Ear itching.",
            "The following symptoms are denied:",
            "Ear fullness.",
            "Ringing involves both ears and is described as continuous and non pulsatile.",
            "Ringing involves the right ear and is described as continuous and non-pulsatile.",
            "Ringing involves the left ear and is described as continuous and non-pulsatile.",
            "Dizzyness is not directly linked to hearing loss.  Episodes are mild and do not invlove room spinning or false sensation of movement.",
            "Dizziness is described as spinning, and there is distortion of the visual environment.",
            "The patient denies significant noise exposure.",
            "The patient reports significant noise exposure.",
            "Noise exposure affected both ears.",
            "Noise exposre was mainly to the right ear.",
            "Noise exposure was mainly to the left ear.",
            "Head trauma, ear surgery, neurosuegery, meningitis, and ototoxic drug history are denied."
        ]
    },
    {
        "label": "ENT:Nasal",
        "values": [
            "The patient is referred for evaluation of nasal problems.",
            "Symptoms have been present for several days.",
            "Symptoms have been present for several weeks.",
            "Symptoms have been present for several months.",
            "Symptoms have been present for several years.",
            "Symptoms have been present for many years.",
            "The following symptoms are reported:",
            "Nasal congestion worse on the right.",
            "Nasal congestion worse on the left.",
            "Nasal congestion equal on both sides.",
            "Nasal discharge that is mucoid and clear.",
            "Nasal discharge that is thick, green and yellow.",
            "Bleeding from the right side of the nose.",
            "Bleeding from the left side of the nose.",
            "Bleeding from both sides of the nose.",
            "Nasal pain.",
            "Decreased sense of smell.",
            "Altered sense of taste.",
            "Facial pain and pressure.",
            "The following symptoms are denied:",
            "Nasal congestion.",
            "Nasal pain.",
            "Nasal discharge.",
            "Nasal bleeding.",
            "Change in the shape of the nose or face.",
            "Change in the sensation of the skin of the nose or face.",
            "Facial pain and pressure.",
            "Facial pain and pressure is described as involving the forehead and the area around the eyes and cheeks.",
            "Facial pain and pressure is worse on the right, described as involving the forehead and area around the eyes and cheek.",
            "Facial pain and pressure is worse on the left, described as involving the forehead and the areas around the eye and cheek.",
            "Symptoms of seasonal allergies such as sneezing, itchy eyes, runny nose, and postnasal drip are denied.",
            "Allergic symptoms such as sneezing, runny nose, itchy nose, postnasal drip, watery eyes and itchy eyes are also reported.",
            "The following treatments have been tried:",
            "Nasal steroid sprays.",
            "Astelin nasal spray.",
            "Over-the-counter nasal decongestant sprays.",
            "Oral decongestion pills.",
            "Nasal irrigation with saline solution.",
            "Allergy referral.",
            "Oral antibiotics.",
            "Several courses of oral antibiotics.",
            "The longest duration of antibiotic therapy has been for 7 days.",
            "The longest duration of antibiotic therapy has been for 10 days.",
            "The longest duration of antibiotic therapy has been for two weeks.",
            "These treatments have not helped significantly.",
            "These treatments have had moderate, but incomplete effect in reducing symptoms.",
            "The patient has experienced good results with these treatments, thus far.",
            "The patient denies any nasal surgery or sinus surgery in the past.",
            "There is no history of nasal or facial trauma.",
            "History is significant for nasal surgery in the past.",
            "History is significant for nasal trauma in the past.",
            "Change in the sensation of the skin of the nose or face.",
            "Change in the shape of the nose or face."
        ]
    },
    {
        "label": "ENT:NeckMass",
        "values": [
            "The patient is referred for evaluation of neck mass.",
            "The mass is on the right side.",
            "The mass is on the left side.",
            "The mass is in the middle of the neck.",
            "It is tender to touch.",
            "It is not tender to touch.",
            "There has been redness of the overlying skin.",
            "There has been no redness of the overlying skin.",
            "There has been drainage from the mass.",
            "There has been no drainage from the mass.",
            "It has been present for several days.",
            "It has been present for several weeks.",
            "It has been present for several months.",
            "It has been present for several years.",
            "It has been present for many years.",
            "No associated fever, chills, weight loss or night sweats.",
            "There has not been significant change in the size of the mass.",
            "The mass has been growing slowly.",
            "The mass fluctuates in size.",
            "At first, the mass was the size of a small pea.",
            "At first, the mass was the size of a large peanut.",
            "Now, the mass is the size of a large peanut.",
            "Now, the mass is the size of an olive.",
            "Now, the mass is the size of a golf ball.",
            "Now, the mass is the size of a tennis ball.",
            "The following symptoms are reported:",
            "Fever.",
            "Chills.",
            "Night sweats.",
            "Weight loss.",
            "The following symptoms are denied:",
            "Neck pain.",
            "Voice change.",
            "Difficulty eating and drinking due to pain or food not passing.",
            "There is neck pain with neck rotation.",
            "There is no neck pain with neck rotation.",
            "No other masses have been seen or felt along the neck or armpits.",
            "The patient has not had any antibiotic therapy.",
            "The patient has had one course of oral antibiotics.",
            "The patient has had more than one course of oral antibiotics.",
            "Mass size was not affected by antibiotic therapy.",
            "The mass became smaller with antibiotic therapy.",
            "The mass grew despite antibiotic therapy.",
            "The longest duration of antibiotic therapy has been for 7 days.",
            "The longest duration of antibiotic therapy has been for 10 days.",
            "The longest duration of antibiotic therapy has been for two weeks."
        ]
    },
    {
        "label": "ENT:Otalgia",
        "values": [
            "The patient is referred for evaluation of ear pain.",
            "The problem has been present for several days.",
            "The problem has been present for several weeks.",
            "The problem has been present for several months.",
            "The problem has been present for several years.",
            "The problem has been present for many years.",
            "Pain involves the right ear.",
            "Pain involves the left ear.",
            "Pain involves both ears.",
            "It is intermittent.",
            "Is continuous.",
            "Pain is described as sharp and intense.",
            "Pain is described as dull with varying severity.",
            "Pain is associated with pressure, and changes in elevation.  This",
            "Pain is not associated with pressure or changes in elevation.",
            "Pain level on scale of 1-10 is: ??   ",
            "There is association with prolonged chewing, jaw movement, or eating tough foods.",
            "There is no association with chewing or jaw movement.",
            "The following symptoms are associated:",
            "Hearing loss.",
            "Dizziness",
            "Ringing.",
            "Ear drainage.",
            "Sensation of fullness in the ear.",
            "Ear itching.",
            "The following symptoms are denied:",
            "Ear fullness.",
            "Ringing involves both ears and is described as continuous and non pulsatile.",
            "Ringing involves the right ear and is described as continuous and non-pulsatile.",
            "Ringing involves the left ear and is described as continuous and non-pulsatile.",
            "Hearing loss involves the right ear.",
            "Hearing loss involves the left.",
            "Hearing loss involves both ears.",
            "Hearing loss has been constant and progressive without fluctuation",
            "Hearing loss fluctuates",
            "The patient denies significant noise exposure.",
            "The patient reports significant noise exposure.",
            "Noise exposure affected both ears.",
            "Noise exposre was mainly to the right ear.",
            "Noise exposure was mainly to the left ear.",
            "Head trauma, ear surgery, neurosuegery, meningitis, and ototoxic drug history are denied.",
            "The patient believes they were sick with cold or flu before symptoms started.",
            "The patient did not have any symptoms of cold or flu before symptoms started.",
            "The patient cannot think of anything that caused the symptoms started.",
            "The following treatments have been tried thus far:",
            "Antibiotic drops.",
            "Oral benzodiazepines.",
            "Decongestants.",
            "Antihistamines.",
            "No therapy has been successful in reducing symptoms."
        ]
    },
    {
        "label": "follow up",
        "values": [
            "follow up"
        ]
    },
    {
        "label": "GERD",
        "values": [
            "Here for evaluation of epigastric abdominal pain",
            "Here for follow up of GERD",
            "Pain is improved with medications",
            "No longer problematic",
            "Pain is burning, acid in character",
            "Provoked by foods",
            "Some sensation of reflux when recumbant",
            "Occasional nocturnal cough",
            "No emesis",
            "No diarrhea",
            "No melena",
            "Pain level (scale of 1-10): ??"
        ]
    },
    {
        "label": "GYNAnnualExam",
        "values": [
            "Here for annual GYN examination",
            "No current gyn problems described by patient",
            "Has complained of ??",
            "Mental status good",
            "No problems w. periods",
            "No bowel or bladder problems"
        ]
    },
    {
        "label": "GYNexam_ACOG",
        "values": [
            "Patient here as new patient",
            "Patient here as established patient",
            "Patient here for consultation",
            "Referring physician: ??",
            "PCP: ??",
            "History present illness: ??",
            "CHANGES SINCE LAST VISIT:",
            "Illnesses: ??",
            "Surgery: ??",
            "New medications: ??",
            "Change in Family History: ??",
            "New allergies: ??",
            "Change in gynecologic history: ??",
            "Change in obstetrical history: ??",
            "Allergies: ??",
            "Last cervical cancer screening: ??",
            "Last mammogram: ??",
            "Last colorectal screening: ??",
            "GYNECOLOGIC HISTORY:",
            "LMP: ??",
            "Age at menarche: ??",
            "Length of flow: ??",
            "Interval between periods: ??",
            "Recent changes: ??",
            "Sexually active: ??",
            "Ever had sex: ??",
            "Number of partners (lifetime): ??",
            "Partner gender: ??",
            "Current method of contraception: ??",
            "OBSTETRICAL HISTORY:",
            "Pregnancies: ??",
            "Abortions: ??",
            "Miscarriages: ??",
            "Premature births (<37 weeks): ??",
            "Live births: ??",
            "Living children: ??",
            "Pregnancy complications: ??",
            "Depression before or after pregnancy: ??",
            "PAST MEDICAL HISTORY:",
            "Noncontributory",
            "No interval changes since ??",
            "Surgeries: ??",
            "Illness (physical and mental): ??",
            "Injuries: ??",
            "Immunizations/TB tests: ??",
            "FAMILY HISTORY:",
            "Noncontributory",
            "No interval changes since ??",
            "Mother: ??",
            "Siblings: ??",
            "Children: ??",
            "Clinical conditions: ?? diabetes, cancer, heart disease, hypertension, hyperlipidemia, DVT, other illnesses",
            "SOCIAL HISTORY:",
            "Noncontributory",
            "Alcohol use: ??",
            "Other drug use (street drugs, prescription drug misuse): ??",
            "Intimate partner violence: ??",
            "Sexual abuse: ??",
            "Health hazards at home/work: ??",
            "Seat belt use: ??",
            "Diet discussed: ??",
            "Folic acid intake: ??",
            "Calcium intake: ??",
            "Regular exercise: ??",
            "Caffeine intake: ??",
            "Advance directives: ??",
            "Organ donation: ??",
            "Other: ??",
            "REVIEW OF SYSTEMS:",
            "General: No weight change, generally healthy, no change in strength or exercise tolerance",
            "Head: No headaches, no vertigo, no injury",
            "Eyes: Normal vision, no diplopia, no tearing, no scotomata, no pain",
            "Ears: No change in hearing, no tinnitus, no bleeding, no vertigo",
            "Nose: No epistaxis, no coryza, no obstruction, no discharge",
            "Mouth: No dental difficulties, no gingival bleeding, no use of dentures",
            "Neck: No stiffness, no pain, no tenderness, no noted masses",
            "Breast: No noted lumps, no tenderness, no swelling, no nipple discharge",
            "Chest: No dyspnea, no wheezing, no hemoptysis, no cough",
            "Heart: No chest pains, no palpitations, no syncope, no orthopnea",
            "Abdomen: No change in appetite, no dysphagia, no abdominal pains, no bowel habit changes, no emesis, no melena",
            "GU: No urinary urgency, no dysuria, no change in nature of urine",
            "Gyn: No change in menses, no dysmenorrheal, no vaginal discharge, no pelvic pain",
            "Musculoskeletal: No pain in muscles or joints, no limitation of range of motion, no paresthesias or numbness",
            "Neurologic: No weakness, no tremor, no seizures, no changes in mentation, no ataxia",
            "Psychiatric: No depressive symptoms, no changes in sleep habits, no changes in thought content"
        ]
    },
    {
        "label": "Headache",
        "values": [
            "Patient here C/O headache.",
            "It was of sudden onset.",
            "The pain began gradually.",
            "The pain has lasted for",
            "Patient has not had a pain like this before.",
            "There is a history of migraines.",
            "There is a history of cluster headaches.",
            "There is a history of tension headaches",
            "There is a history of sinus infections leading to headaches.",
            "This headache is similar to past episodes.",
            "The pain is an intense, throbbing, pounding pain that involves one temple. (Sometimes the pain is located in the forehead, around the eye, or at the back of the head).",
            "The pain is on one side of the head. It tends to vary in location going from side to side with different attacks.",
            "The patient can tell when the headache is coming sometimes by several hours.",
            "The pain is like a tight band around the head.",
            "The pain is dull.",
            "The pain is throbbing.",
            "The pain is sharp.",
            "There is nausea.",
            "There is no nausea.",
            "There is vomiting.",
            "There has been no vomiting.",
            "The pain seems to be caused by bright light.",
            "There is sensitivity to light and sound.",
            "The pain seems to be caused by stress.",
            "The pain seems to be caused by certain foods.",
            "There is a history of heavy caffeine use, recently stopped.",
            "The patient has recently stopped using for pain.",
            "The pain has no relation to food or diet.",
            "There is a history of head trauma.",
            "There is no history of head trauma.",
            "The patient has had a stroke in the past.",
            "There is no history of stroke.",
            "The patient has been exposed to meningitis.",
            "There is no history of exposure to meningitis.",
            "The pain is made worse by straining or bending over.",
            "The headache is relieved by",
            "The pain is not related to her period.",
            "The headache is related to her menstrual cycle.",
            "The patient is using ?? for BCP.",
            "The pain is located ??",
            "There is a family history of cluster headaches.",
            "There is no family history.",
            "There has been a change in sleep patterns.",
            "There is no change in sleep patterns.",
            "The patient is a smoker.",
            "Patient has recently quit smoking.",
            "Patient is a non smoker.",
            "These headaches seem to occur in clusters, once or twice a day, sometimes more often.",
            "The pain can last for 30 minutes or more.",
            "The pain can sometimes wake the patient up from sleep.",
            "The pain sometimes feels like a hot poker in the eye.",
            "The pain causes the patient to pace the floor and bang head on the wall to try to stop the pain."
        ]
    },
    {
        "label": "Headache general",
        "values": [
            "Patient here C/O headache.",
            "It was of sudden onset.",
            "The pain began gradually.",
            "The pain has lasted for ??",
            "Patient has not had a pain like this before.",
            "There is a history of migraines.",
            "There is a history of cluster headaches.",
            "There is a history of tension headaches",
            "There is a history of sinus infections leading to headaches.",
            "This headache is similar to past episodes.",
            "The pain is an intense, throbbing, pounding pain that involves one temple. (Sometimes the pain is located in the forehead, around the eye, or at the back of the head).",
            "The pain is on one side of the head. It tends to vary in location going from side to side with different attacks.",
            "The patient can tell when the headache is coming sometimes by several hours.",
            "The pain is like a tight band around the head.",
            "The pain is dull.",
            "The pain is throbbing.",
            "The pain is sharp.",
            "There is nausea.",
            "There is no nausea.",
            "There is vomiting.",
            "There has been no vomiting.",
            "The pain seems to be caused by bright light.",
            "There is sensitivity to light and sound.",
            "The pain seems to be caused by stress.",
            "The pain seems to be caused by certain foods.",
            "There is a history of heavy caffeine use, recently stopped.",
            "The patient has recently stopped using for pain.",
            "The pain has no relation to food or diet.",
            "There is a history of head trauma.",
            "There is no history of head trauma.",
            "The patient has had a stroke in the past.",
            "There is no history of stroke.",
            "The patient has been exposed to meningitis.",
            "There is no history of exposure to meningitis.",
            "The pain is made worse by straining or bending over.",
            "The headache is relieved by ??",
            "The pain is not related to her period.",
            "The headache is related to her menstrual cycle.",
            "The patient is using ?? for BCP.",
            "The pain is located ??",
            "There is a family history of cluster headaches.",
            "There is no family history.",
            "There has been a change in sleep patterns.",
            "There is no change in sleep patterns.",
            "The patient is a smoker.",
            "Patient has recently quit smoking.",
            "Patient is a non smoker.",
            "These headaches seem to occur in clusters, once or twice a day, sometimes more often.",
            "The pain can last for 30 minutes or more.",
            "The pain can sometimes wake the patient up from sleep.",
            "The pain sometimes feels like a hot poker in the eye.",
            "The pain causes the patient to pace the floor and bang head on the wall to try to stop the pain.",
            "Family History: ??"
        ]
    },
    {
        "label": "Headache Migraine",
        "values": [
            "I had the pleasure of evaluating this patient in Neurology Clinic, as you know, ??he is a ?? year old ??male with a history of ??refractory migraine headache disorder since ??the onset of puberty.",
            "Patient has a chronic daily headache with a superimposed moderate to severe escalating headache about ??2-3 times a week.",
            "Patient complains of a moderate to severe escalating headache about ??2-3 times a week.  Denies a chronic daily headache.",
            "Headaches tend to cluster, the patient will have a series of headaches over ?? weeks then may go ??week without pain.",
            "Over time, the character of the pain has remained relatively ??stable.",
            "Prodrome: The patient can predict headache onset, sometimes by ?? hours because of symptoms of ??.",
            "Patient cannot identify a prodrome phenomenon prior to head pain.",
            "Moderate to severe pain escalates:  ??Instantly Gradually ??over ??hours and lasts for ??hours.",
            "Escalating head pain starts in the ??right ??left ??bilateral posterior head and radiates to the ??right ??left ??bilateral ??temple.",
            "Escalating head pain starts in the ??right ??left ??bilateral ??frontal ??temporal region and radiates to the ??right ??left ??bilateral ??trigeminal distribution.",
            "Pain is associated with photophobia, phonophobia, nausea, vomiting, and a pulsating sensation.  There has never been an associated focal neurological abnormality with the head pain.",
            "Patient denies: photophobia, phonophobia, nausea, vomiting, or a pulsating sensation.  There has never been an associated focal neurological abnormality with the head pain.",
            "No bowel or bladder issues.",
            "The pain ??does not awaken the patient up from sleep.",
            "When the headache is intense or persists it is associated with: ??right/left/bilateral ??face, arm, leg ??paresthesias.",
            "With headaches: Patient ??denies experiences an aura with visual sensation of scintillating scotoma. ??No blurred vision; no visual field loss; no double vision.  ??No difficulty chewing; no dysphagia; no dysarthria.",
            "Patient acknowledges a rebound component to the headache with ??regular use of ??Excedrin.",
            "Triggers: Menstrual cycle, weather change, foods, after stressors are over, bright light, lack of sleep, straining or bending over.",
            "Triggers: None identified",
            "Patient ??denies history of head trauma associated with loss of consciousness.",
            "History of head trauma associated with loss of consciousness in ?? associated with ??.",
            "No exposure or past history of meningitis.",
            "Sinus: No history of sinusitis.",
            "Sinus: History of recurrent sinusitis treated with one or a combination of ??antibiotics ??antihistamines ??nasal sprays (OTC, steroid), ??decongestants at various intervals with?? significant relief ??albiet temporary.",
            "Temporal Mandibular Joint: Normal",
            "Temporal Mandibular Joint: Patient has previously been diagnosed ??and treated for TMJ syndrome.  ??Possibly with some relief but not sustained relief.",
            "Temporal Mandibular Joint: ??Right sided Left sided Bilaterally and is problematic, contributing to pain.",
            "Nothing to suggest jaw claudication; No abnormal lumps or bumps in the temporal region.",
            "No history to suggest ??stroke or ??seizure.",
            "Mood is generally ??good except when the patient is having is complaints of pain.",
            "Mood is irritable in general.",
            "Mood: Depressed, Anxious, Patient has a history of bilpolar affective disorder. ??Symptoms are controlled with medication.  ??Symptoms are suboptimally controlled.",
            "Fatigue: Increased in general, with or without head pain.",
            "Fatigue: Increased, associated with migraine",
            "Energy level: normal",
            "SLEEP: Epworth Sleepiness Score: ?? (report is included in the chart.)  Difficulty sleeping: denied;  Problems going to sleep: ??denied; Early morning awakening: ??denied; Snoring: ??denied; Apnea: ??denied; Awakens refreshed: ??yes.",
            "Short term memory is problematic.  Primarily increased latency of recall, for example patient reports needing an item in one room, going to look for the item in the appropriate room but once there not  remembering. Finally remembering but maybe much later.",
            "Difficulty concentrating when experiencing a migraine, otherwise, short term memory is normal compared with peers.",
            "Family history of migraine: ??Denied ??mom, ??maternal paternal.",
            "Nortriptyline: ??Not effective;??Took the edge off; ??Associated with side effects of: ??;",
            "Neurontin: ??Not effective;??Took the edge off; ??Associated with side effects of: ??;",
            "Topamax: ??Not effective;??Took the edge off; ??Associated with side effects of: ??;",
            "Verapamil: ??Not effective;??Took the edge off; ??Associated with side effects of: ??;",
            "Beta blockers: ??Not effective;??Took the edge off; ??Associated with side effects of: ??;",
            "Flexeril: ??Not effective, ??Not effective;??Took the edge off; ??Associated with side effects of: ??; ??Was effective in addressing ??muscle spasm but not effective for headaches;",
            "Effexor: ??Not effective,  ??Was effective in addressing ??depression but not effective for for headaches;",
            "Imitrex: ??Not effective",
            "CPAP: ??Compliant. ??Was effective in addressing apnea but did not improve headache.",
            "Imitrex: ??Not effective;??Took the edge off; ??Associated with side effects of: ??;",
            "Previous consultation with: Dr. ??. Patient was compliant with recommendations but without improvement of pain; ??No therapeutic options offered ??per patient.",
            "Pain Clinic evaluation, ??Portland OR: ??Patient was compliant with recommendations but without improvement of pain; ??No therapeutic options offered ??per patient."
        ]
    },
    {
        "label": "Headache Tension",
        "values": [
            "?? yr old female with C/O daily headaches for a year. The headaches are in the frontal region and feel like pressure. Also had neck and shoulder muscle tightness. The headaches occur daily for but vary in severity. The headaches are worse with stress. There is no nausea, vomiting or vision disturbance. There is no sleep disturbance. Feels anxious and stressed daily because of work. There are no lateralized motor or sensory symptoms in limbs. No previous blackouts or seizures. Has had occasional scalp paresthesias which can vary in location",
            "?? yr old male with C/O daily headaches for a year. The headaches are in the fronto-temporal region and feel like pressure.   He also had neck and shoulder muscle tightness. The headaches occur daily for but vary in severity. The headaches are worse with stress. There is no nausea, vomiting or vision disturbance. There is  sleep disturbance with insomnia. He feels anxious and stressed daily because of her work. There are no lateralized motor or sensory symptoms in limbs. He denies previous blackouts or seizures. She has had occasional scalp paresthesias which can vary in location",
            "?? yr old ?? with C/O daily headaches for a ??",
            "The headaches are in the ?? region and feel like pressure.",
            "?? also had neck and shoulder muscle tightness.",
            "The headaches occur daily for but vary in severity.",
            "The headaches are worse with stress.",
            "There is no nausea, vomiting or vision disturbance.",
            "There is  sleep disturbance with insomnia.",
            "She feels anxious and stressed daily because of her work.",
            "There are no lateralized motor or sensory symptoms in limbs.",
            "?? denies previous blackouts or seizure",
            "Blood tests done ?? were reportedly normal",
            "Blood tests done ?? showed ??",
            "PAST MEDICAL HISTORY: Anxiety and stress. ",
            "FAMILY HISTORY: Parents are alive and well",
            "SOCIAL HISTORY: Does not smoke or drink alcohol. ??Married ",
            "ALLERGIES: NKDA. ",
            "MEDICATIONS: ??",
            "Comprehensive ROS: Emotional: No Anxiety, Depression Cardiac: No Chest pain Respiratory: No SOB, Cough, Abdominal No Indigestion, Urinary: No dysuria, continent Oncology: No Cancer, Constitutional:. No Weight loss, No fever Hematology: No Anemia, Bleeding Skin: No  skin rash. Rheumatogic: No Joint swelling Endocrinology: No Diabetes/Thyroid disease Eye: No vision disturbance. ENT: Normal hearing.",
            "Blood tests for her annual physical 2010 were apparently normal."
        ]
    },
    {
        "label": "Hemmorhoids,AnalFissure",
        "values": [
            "here with c/o BRBPR on tissue x  days.",
            "here with c/o pain on defecation x  days.",
            "Associated with scant blood on tissue.",
            "Denies abdominal pain, fever.",
            "Has had associated constipation.",
            "Denies unusual foods, travel.",
            "Eats low fiber diet.",
            "Pain level (scale of 1-10): ??"
        ]
    },
    {
        "label": "Hypothyroid,Hyperthyroid",
        "values": [
            "Here for re-evaluation of hypothyroidism",
            "Here for re-evaluation of hyperthyroidism",
            "No new complaints, feeling basically well",
            "Taking medications without difficulties",
            "No palpitations, or sensation of heart racing",
            "No constipation or diarrhea",
            "No peripheral edema"
        ]
    },
    {
        "label": "InguinalHernia",
        "values": [
            "Here because of a lump in the right groin.",
            "Here because of a lump in the left groin.",
            "Referred by Dr. ?? for ??",
            "C/O pain in the right groin.",
            "C/O pain in the left groin",
            "A lump has been present since this began",
            "There is not been a lump.",
            "The problem began on ?? when he was doing some heavy lifting. A tear was felt and the lump appeared.",
            "This began while he was at work.",
            "The patient was not at work at the time.",
            "Lifting or straining makes the pain worse.",
            "Lifting also makes the lump larger.",
            "The lump is easily reducible by the patient.",
            "The mass has lately become more difficult to reduce.",
            "The patient has a problem with constipation",
            "There is no constipation.",
            "There is difficulty urinating.",
            "There is no urinary difficulty.",
            "There was a previously repaired hernia."
        ]
    },
    {
        "label": "Kneepain",
        "values": [
            "Here with c/o knee pain x ??",
            "Pain worse with stair climbing",
            "Pain worsened with torsion",
            "Denies known acute trauma",
            "Denies instability, locking, or clicking",
            "Pain level (scale of 1-10): ??",
            "pain at night"
        ]
    },
    {
        "label": "Medicare Annual Wellness Exam",
        "values": [
            "Here for breast exam and Pap/pelvic",
            "Here for Medicare Annual Wellness visit",
            "It has been 2 years since last exam",
            "It is less than 2 years since last exam but patient is high risk due to: ??",
            "Medications as previously",
            "Medications: ??",
            "Drug allergies: ??",
            "No known drug allergies",
            "PMH, FH, Problem list updated",
            "Current providers involved in patient care: ??",
            "ROS reveals the following pertinent positives: ??",
            "ROS is entirely unremarkable",
            "Last mammogram: ??"
        ]
    },
    {
        "label": "Menopausal symptoms",
        "values": [
            "This woman is here for a re-check",
            "Her menopausal symptoms are well-controlled",
            "Her menopausal symptoms are not well controlled",
            "She has hot flashes and night sweats, frequently.",
            "She has only occasional hot flashes.",
            "Complains of insomnia.",
            "Complains of vaginal dryness.",
            "Current medications for menopausal symptoms ??"
        ]
    },
    {
        "label": "NauseaVomiting",
        "values": [
            "Patient here with acute onset of nausea and vomiting",
            "Denies possibility of pregnancy",
            "Not associated with headaches",
            "Associated with headaches",
            "Associated with headaches following blunt head injury",
            "Severe persistent abdominal pain lasting longer than 1 hour",
            "Associated with hematemesis",
            "No hematemesis, no melena",
            "Symptoms followed eating large meal",
            "Symptoms followed ingesting large quantities of alcohol",
            "Symptoms followed eating potentially contaminated food",
            "Associated with dizziness, vertigo",
            "No history jaundice",
            "Recent onset of jaundice",
            "Pain level (scale of 1-10): ??"
        ]
    },
    {
        "label": "Neurologic exam",
        "values": []
    },
    {
        "label": "PE Age 13-16 yrs",
        "values": [
            "Interval history:",
            "Diet: ??",
            "Appetite: ??",
            "Physical activity: ??",
            "Illnesses, stomach, headache, fatigue: ??",
            "Sexual activity: ??",
            "Meds/vitamins: ??",
            "Weight loss/gain: ??",
            "Tobacco/alcohol/drug use: ??",
            "Accidents: ??",
            "Family hx: ??",
            "Exposure to tobacco smoke: ??",
            "Growth/school progress (achievement, sports, peer relationships, attendance, school vision or hearing problems): ??"
        ]
    },
    {
        "label": "PE Age 17-18 yrs",
        "values": [
            "Interval history:",
            "Diet: ??",
            "Appetite: ??",
            "Physical activity: ??",
            "Illnesses, stomach, headache, fatigue: ??",
            "Sexual activity: ??",
            "Meds/vitamins: ??",
            "Weight loss/gain: ??",
            "Tobacco/alcohol/drug use: ??",
            "Accidents: ??",
            "Family hx: ??",
            "Exposure to tobacco smoke: ??",
            "Growth/school progress (achievement, sports, peer relationships, attendance, school vision or hearing problems): ??"
        ]
    },
    {
        "label": "PE Age 4-5 yrs",
        "values": [
            "Interval history:",
            "Diet: ??",
            "Illnesses: ??",
            "Stools: ??",
            "Meds/vitamins: ??",
            "Accidents: ??",
            "Sleep pattern: ??",
            "Exposure to tobacco smoke: ??",
            "Growth/development:",
            "Hops on one foot",
            "Counts 4 pennies",
            "Copies a square",
            "Catches, throws a ball",
            "Plays with several children",
            "Recognizes 3-4 colors",
            "Knows opposites",
            "Knows name, address, phone number"
        ]
    },
    {
        "label": "PE Age 6-8 yrs",
        "values": [
            "Interval history:",
            "Diet: ??",
            "Illnesses, stomach, headache, fatigue: ??",
            "Fatigue, nightmares, enuresis: ??",
            "Meds/vitamins: ??",
            "Weight loss/gain: ??",
            "Accidents: ??",
            "Family hx: ??",
            "Exposure to tobacco smoke: ??",
            "Growth/school progress (achievement, sports, peer relationships, attendance, school vision or hearing problems): ??"
        ]
    },
    {
        "label": "PE Age 9-12 yrs",
        "values": [
            "Interval history:",
            "Diet: ??",
            "Appetite: ??",
            "Physical activity: ??",
            "Illnesses, stomach, headache, fatigue: ??",
            "Sexual activity: ??",
            "Meds/vitamins: ??   ",
            "Weight loss/gain: ??",
            "Tobacco/alcohol/drug use: ??",
            "Accidents: ??",
            "Family hx: ??",
            "Exposure to tobacco smoke: ??",
            "Growth/school progress (achievement, sports, peer relationships, attendance, school vision or hearing problems): ??"
        ]
    },
    {
        "label": "PSYCHIATRY:Interview_anxiety",
        "values": [
            "HPI",
            "Onset: ??",
            "Precipitants: ??.",
            "Quality: ??",
            "Radiation: ??",
            "Severity: ??",
            "Timing: ??",
            "PAST PSYCHIATRIC HISTORY",
            "No reported past psychiatric history.",
            "First psychiatric contact: ??",
            "Past hospitalizations: ??",
            "Medication history: ",
            "Medication Name: ?? Dose: ?? Therapeutic Effects: ?? Side Effects/Adverse Reactions: ?? Date Started: ?? Date Stopped: ?? Reason Stopped: ??",
            "Current psychiatric care: ??",
            "Past suicide attempts: ??",
            "Deliberate self harm: ??",
            "SUBSTANCE ABUSE HISTORY",
            "No reported substance abuse history.",
            "Reports EtOH use. Amount used: ??. Duration of use: ??. Precipitants: ??. Attitude toward use: ??. History of withdrawal: ??. ",
            "Reports marijuana use. Amount used: ??. Duration of use: ??. Precipitants: ??. Attitude toward use: ??. History of withdrawal: ??. ",
            "Reports heroin use. Amount used: ??. Duration of use: ??. Precipitants: ??. Attitude toward use: ??. History of withdrawal: ??. ",
            "Reports cocaine use. Amount used: ??. Duration of use: ??. Precipitants: ??. Attitude toward use: ??. History of withdrawal: ??. ",
            "Reports ?? use. Amount used: ??. Duration of use: ??. Precipitants: ??. Attitude toward use: ??. History of withdrawal: ??. ",
            "Longest time sober: ??.",
            "FAMILY HISTORY",
            "Parents: ??",
            "Siblings: ??",
            "Relatives with mental illness: ??. Illness: ??. Treatment: ??.",
            "Relevant medical history: ??",
            "SOCIAL HISTORY",
            "Childhood: ??",
            "Relationship: Currently in a relationship that has lasted ??.",
            "Relationship: Not currently in a relationship.",
            "Relationship: Recently out of a relationship that lasted ??. ",
            "Education: ??",
            "Employment: ??",
            "Religious affiliations: ??",
            "Cultural background: ??",
            "Legal history: ??",
            "Abuse: ??",
            "REVIEW OF SYSTEMS",
            "Positive for:",
            "Negative for:",
            "apprehensive expectation.",
            "autonomic hyperactivity.",
            "Excessive worry",
            "Muscle tension",
            "Irritability, restlessness",
            "Sleep impairment due to any of the above.",
            "persistent irrational fears.",
            "recurrent and intrusive recollections.",
            "recurrent obsessions or compulsions.",
            "recurrent severe panic attacks.",
            "vigilance and scanning."
        ]
    },
    {
        "label": "SHAH GYN EXAM",
        "values": [
            "Here for annual GYN examination",
            "No current gyn problems described by patient",
            "Has complained of ??",
            "No problems w. periods",
            "No bowel or bladder problems",
            "No family history of GYN/ breast, or colon cancer.",
            "LMP",
            "Surgical history",
            "Currently taking oral BC pills",
            "Gravida/  Para",
            "Patient is postmenopausal",
            "Denies vaginal bleeding or discharge. denies itching, rectal bleeding, urinary frequency, or dysuria. Denies Breast discharge or bleeding from nipple.",
            "No history of STDs.",
            "No history of smoking."
        ]
    },
    {
        "label": "SutureLaceration",
        "values": []
    },
    {
        "label": "SutureRemoval",
        "values": [
            "Here for suture removal",
            "Doing well, no problems with wound",
            "No pain, no discharge"
        ]
    },
    {
        "label": "UmbilicalHernia",
        "values": [
            "States that pain was felt in the umbilicus when lifting.",
            "This began ??",
            "Patient has noted a tender mass.",
            "There is a non tender mass in the umbilicus.",
            "The size increases when lifting or straining.",
            "Pain increases with lifting or straining.",
            "The patient has difficulty urinating.",
            "There is no difficulty urinating.",
            "There is constipation.",
            "There is no constipation."
        ]
    },
    {
        "label": "URI,bronchitis,sinusitis,OM,pharyngitis",
        "values": [
            "Here with acute onset rhinorrhea, nasal and chest congestion",
            "Here with 2d h/o right ear pain.",
            "Here with 2d h/o left ear pain.",
            "Here with 2d h/o b/l ear pain.",
            "Here with acute onset sore throat, difficulty swallowing.",
            "Here with acute onselt sinus pain, headaches, malaise",
            "No associated cough",
            "Associated with nonproductive cough",
            "Associated with mildly productive cough",
            "Associated with cough productive of clear sputum",
            "Associated with cough productive of green sputum.",
            "Denies fever, chills, GI complaints.",
            "Low grade fever, chills, no GI complaints.",
            "Fever to ??, with chills.  No GI complaints"
        ]
    },
    {
        "label": "UTI",
        "values": [
            "Dysuria, urinary frequency for ?? days",
            "No fever,chills",
            "No flank pain",
            "No bladder tenderness"
        ]
    },
    {
        "label": "Varicose Veins",
        "values": [
            "Varicose veins in ??",
            "Heaviness",
            "Fatigue",
            "Difficulty standing for prolonged periods"
        ]
    },
    {
        "label": "Warts",
        "values": [
            "Here for treatment of solitary verrucous skin lesion",
            "Here for treatment of multiple verrucous lesions",
            "Lesions located ??"
        ]
    },
    {
        "label": "WeightLoss",
        "values": [
            "Here with concern over weight loss",
            "Has lost ?? lbs in  months",
            "Associated with loss of appetite",
            "Associated with night sweats, fatigue, fever, persisting cough",
            "Has increased exercise regimen recently",
            "Associated with increased thirst, polyuria, fatigue",
            "No change in thirst, urination, defacation",
            "No associated abdominal pains",
            "Associated with abdominal pain",
            "Associated with constipation, diarrhea, abdominal bloating",
            "No melanotic stools noted",
            "Episodic melanotic and occasionally bloody stools",
            "Sensation of eye bulging, tremor, sweating",
            "Associated with sleep changes, anhedonia, anxiety, situational stresses",
            "Perceives self as being overweight",
            "No change in menstrual pattern",
            "Pain level (scale of 1-10): ??"
        ]
    },
    {
        "label": "Work Note",
        "values": [
            "The patient name above was seen by Dr. Ogleh Nesheiwat for medical issues on ,    . Please excuse the patient from school/work. Patient is to return to school/work on     . Restriction:"
        ]
    }
];

export default notesTemplates;